import { AxiosInstance } from 'axios';
import DepartmentRepositoryInterface, {
  ApiCreateDepartmentInterface,
  DepartmentInterface,
} from '@/services/Departments/Interfaces';

export default class DepartmentRepository implements DepartmentRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async getAllDepartments(): Promise<DepartmentInterface[]> {
    const res = await this.axios.get('/auth/departments');

    return res.data;
  }

  public async getDepartmentsByIds(departmentIds: string[]): Promise<DepartmentInterface[]> {
    const query = departmentIds.map((id) => `ids[]=${id}`).join('&');
    const res = await this.axios.get(`/auth/departments?${query}`)

    return res.data;
  }

  public async createDepartment(data: ApiCreateDepartmentInterface): Promise<boolean> {
    const res = await this.axios.post('/auth/departments', data);

    return res.status === 201;
  }

  public async editDepartment(id: string, data: ApiCreateDepartmentInterface): Promise<boolean> {
    const res = await this.axios.patch(`/auth/departments/${id}`, data);

    return res.status === 201;
  }

  public async getDepartmentById(departmentId: string): Promise<DepartmentInterface> {
    const res = await this.axios.get(`/auth/departments/${departmentId}`);

    return res.data;
  }

  public async deleteDepartment(departmentId: string): Promise<void> {
    await this.axios.delete('/auth/departments', { data: { id: departmentId } });
  }
}
